import { styled } from "styled-components";

import { poppins_body_md_medium } from "../../shared/font/poppins/body";
import { scrollBarStyle } from "../../styles/mixin";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  position: relative;
  width: 100%;
  height: 100%;
`;

export const EditorBox = styled.div<{ $disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: var(--Spacing-12, 1.2rem) var(--Spacing-16, 1.6rem);
  align-items: flex-start;
  flex: 1 0 0;
  width: 100%;
  height: 100%;
  border-radius: 0.4rem;
  border: 1px solid var(--Color-Common-Border-Secondary, #b1b8c4);
  background: var(--Color-Common-Bg-Primary, #fff);
  color: var(--Color-Common-Text-Primary, #2a2f37);
  box-sizing: border-box;
  outline: none;
  cursor: text;
  ${poppins_body_md_medium}
  overflow: auto;
  ${scrollBarStyle}

  &:focus-visible {
    outline: none;
  }

  ${({ $disabled }) =>
    $disabled &&
    `
    color: var(--Color-Common-Text-Secondary, #515C6C);
    border: 1px solid var(--Color-Common-Border-Secondary, #b1b8c4);
    background: var(--Color-Common-Bg-Secondary, #f0f2f4);
    cursor: default;
  `}

  &:focus {
    border: 1px solid #fff;
    outline: none;
  }
  p {
    width: 100%;
  }

  ul {
    list-style-type: disc;
    padding-left: 1.6rem;
    margin-top: 0.4rem;
  }

  ol {
    list-style-type: decimal;
    padding-left: 1.6rem;
    margin-top: 0.4rem;
  }

  li {
    display: list-item;
    list-style-type: inherit;
  }
`;

export const Placeholder = styled.span`
  position: absolute;
  top: 1.2rem;
  left: 1.8rem;
  right: 1.6rem;
  color: #515c6c;
  opacity: 0.5;
  ${poppins_body_md_medium}
  white-space: pre-line;
  pointer-events: none;
`;
